import { QueryClient } from '@tanstack/react-query';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      staleTime: 30_000,
      // Данные должны быть свежими при возвращении пользователя на сайт/вкладку
      refetchOnWindowFocus: true,
      refetchOnReconnect: true,
    },
  },
});
